import {
    CUSTOM_ROLE,
    DEFAULT_ROLES,
    RELATIONS,
    USER_RELATIONS
} from '../../app/root/constants'

const pt = {
    dashboard: {
        dashboard: 'Dashboard',
        mapView: 'MapView',
        switcherHoverTooltip: 'Defina e salve sua visualização padrão',
        defaultViewUpdateFail:
            'Falha ao atualizar a visualização padrão do painel',
        reports: 'Relatórios for the last 30 days',
        addressUpdateSuccess: 'Endereço de localização atualizado com sucesso',
        addressUpdateFail: 'Falha ao atualizar o endereço da localização',
        deviceStatusTooltipText: {
            inactive: 'These devices são not in use',
            critical: 'Estes dispositivos requerem inspecção',
            info: 'Os dispositivos estão a funcionar normalmente',
            warning:
                'Os dispositivos possivelmente têm problemas de conectividade ou a bateria está fraca'
        },
        loggedInAs: 'Logado como: '
    },
    customers: {
        customer: 'Cliente',
        customers: 'Clientes',
        plan: 'Plano de software',
        noCustomers: 'Não foram encontrados clientes',
        noCustomer: 'O cliente não foi encontrado',
        hotswapPortal: 'Portal HotSwap',
        hotswapPortalAccess: 'Permitir acesso ao processo de Hot Swap',
        hotswapUpdateService: 'Serviço de Atualização',
        hotswapUpdateServiceAccess: 'Permite a opção de serviço de atualização',
        hotswapWelcomeEmail: 'Email de boas-vindas do HotSwap',
        customerUsersTable: 'Tabela de Usuários do Cliente',
        errorGettingUsersListForCustomer: 'Erro ao obter a lista de usuários'
    },
    hotSwap: {
        capacityIssueMessage:
            'Caros clientes, devido à atual alta carga de trabalho causada por férias e pedidos JERRY3, as reservas Hotswap são liberadas todas as quintas-feiras às 15h. Se as reservas Hotswap não forem possíveis no momento, pedimos um pouco de paciência. Atualizamos as capacidades semanalmente. Em caso de dúvidas, entre em contato diretamente com m.weigert@traplinked.com.',
        hotSwap: 'HotSwap',
        hotSwapAdmin: 'Admin HotSwap',
        hotSwapOrders: 'Pedidos HotSwap',
        startHotSwap: 'Iniciar HotSwap',
        hotSwapVideoManual: 'Manual em vídeo do HotSwap',
        videoNotSupported: 'Seu navegador não suporta a tag de vídeo.',
        hotSwapType: 'Tipo de Hotswap',
        swapReplacment: 'Substituição de Dispositivo',
        description:
            'Alguns dos seus dispositivos podem gastar mais bateria do que o esperado. Para corrigir isso, desenvolvemos um novo firmware e os dispositivos antigos precisam ser trocados. Nesta página, você pode gerenciar todo o processo.',
        introVideo: 'Vídeo de introdução',
        welcomeTitle: 'Bem-vindo ao nosso processo de HotSwap',
        welcomeDesc:
            'Estamos felizes por tê-lo a bordo. Aqui estão algumas dicas rápidas para começar.',
        summary: {
            changeLocation: 'Alterar Localização'
        },
        hotSwapTableEmptyListMessage:
            'Lamentamos, mas não há itens de troca a quente para exibir no momento. Por favor, verifique mais tarde ou entre em contato com o suporte para obter assistência.',
        swap_by_user: {
            label: 'Encomendar dispositivos de substituição',
            title: 'Substitua dispositivos por si mesmo',
            description:
                'Enviamos-lhe dispositivos de substituição e você faz a troca por conta própria',
            features: {
                1: 'Encomendar dispositivos de substituição',
                2: 'Ligue os novos dispositivos e desligue os antigos',
                3: 'Flexível sempre que precisar'
            },
            stepper: {
                firstStepHeader: 'Agendando o envio',
                firstStepSubHeader: 'Quando devemos enviar os dispositivos?',
                secondStepHeader: 'Endereço de entrega',
                secondStepSubHeader:
                    'Para onde devemos entregar os dispositivos?',
                thirdStepHeader: 'Resumo',
                thirdStepSubHeader: 'Confirme o seu pedido de HotSwap'
            },
            btnText: 'Encomendar dispositivos',
            summary: {
                date: 'Data de entrega',
                address: 'Endereço de entrega'
            },
            successTitle: 'HotSwap agendado com sucesso',
            successDesc:
                'Parabéns. Começaremos a preparar os seus dispositivos e enviá-los-emos a tempo.',
            footerText: 'Tracking Number:',
            trackingLink: 'Link de rastreamento:',
            detailsPageText: 'Shipping',
            termsAndConditonsLinkPart: 'Concordo com o HotSwap',
            termsAndConditonsLink: 'Termos e Condições',
            termsAndConditonsTextHeader: 'Condições de HotSwap',
            termsAndConditonsTextFirstParagraph:
                'No contexto do processo de HotSwap, você concorda com as seguintes condições:',
            termsAndConditonsTextSecondParagraph:
                "Para a troca de dispositivos de armazém, por favor, crie um novo local na aplicação traplinked e nomeie-o como ['Nome da sua empresa' + Despacho de Armazém Hot Swap]. Mova todos os dispositivos LoRa que atualmente estão no seu armazém para este local recém-criado para facilitar a troca suave de dispositivos.",
            termsAndConditonsTextThirdParagraph:
                'Para a troca de dispositivos localizados nos locais dos clientes, solicitamos gentilmente que verifiquem a atribuição na aplicação traplinked. Se não criaram nenhuma localização (de cliente) ou se não utilizam a nossa funcionalidade de localização porque trabalham apenas através da interface traplinked, por favor, entrem em contato connosco antes de reservar dispositivos de substituição através deste portal.',
            termsAndConditonsTextFourthParagraph:
                'Como parte do processo HotSwap, você concorda em devolver os dispositivos trocados para nós (traplinked GmbH, Zollhof 7, 90443 Nuremberg) dentro de 7 dias após a conclusão bem-sucedida do processo HotSwap. Nós cobriremos os custos de envio, e o rótulo de devolução será incluído com os seus dispositivos de substituição. Se houver atrasos no envio de devolução devido às suas ações, quaisquer custos adicionais incorridos podem ser repassados a você. Precisamos dos dispositivos trocados para acelerar a revisão de todos os sistemas o mais rápido possível.',
            termsAndConditonsTextFivethParagraph:
                'Estamos disponíveis para ajudá-lo e responder a quaisquer perguntas que possa ter durante o processo de HotSwap. Agradecemos pela sua cooperação e compreensão.'
        },
        update_service: {
            label: 'Agendar uma data',
            title: 'Serviço de atualização por traplinked',
            description:
                'Atualizamos os seus dispositivos na localização atual',
            features: {
                1: 'Agendar um compromisso',
                2: 'Atualizado por um técnico da traplinked',
                3: 'Rápido e confortável'
            },
            stepper: {
                firstStepHeader: 'Agendar Serviço de Atualização',
                firstStepSubHeader: 'Quando o técnico da traplinked deve vir?',
                secondStepHeader: 'Endereço da localização',
                secondStepSubHeader: 'Qual é a localização?',
                thirdStepHeader: 'Resumo',
                thirdStepSubHeader:
                    'Confirme a reserva do Serviço de Atualização'
            },
            btnText: 'Agendar um compromisso',
            summary: {
                date: 'Data e hora',
                address: 'Endereço da localização'
            },
            successTitle: 'Serviço de atualização reservado com sucesso',
            successDesc:
                'Parabéns. O nosso técnico estará na localização definida na data e hora solicitadas.',
            footerText: 'Technician:',
            detailsPageText: 'Update Service'
        },
        rememberAddress: 'Lembrar endereço de entrega',
        saveAddress: 'Guarde este endereço para a próxima troca.',
        backToDashboard: 'Voltar ao painel',
        accordionDevicesTable: {
            exchangeDevice: 'Dispositivo de Troca',
            connectivity: 'Conectividade',
            hbInterval: 'Intervalo HB',
            trapSide: 'Lado da Armadilha',
            wifiData: 'Dados WiFi'
        },
        carrier: 'Transportadora'
    },
    locations: {
        storageSectionTitle: 'Armazenamento',
        storageSectionNetworkDevicesTitle: 'Dispositivos de rede',
        storageSectionDevicesTitle: 'Dispositivos',
        devicesListTitle: 'Dispositivos',
        dragAndDropMsg: 'Arraste n pino de gota aqui!',
        floorPlanLoadingError:
            'Erro durante o carregamento da planta baixa. Por favor, tente novamente',
        locations: 'Locais',
        noLocations: 'Não há locais disponíveis',
        searchUser: 'Pesquisa user',
        pleaseSelectLocation: 'Por favor seleccione um local',
        sureNotToSaveLocation: `Tem a certeza de que não quer salvar um novo local`,
        addSubLocation: 'Acrescentar sub-location',
        addDevices: 'Adicionar dispositivos',
        removeLocation: 'Remover local',
        devices: 'Dispositivos',
        network: 'Rede',
        networkDevice: 'Dispositivo de rede',
        overview: 'Visão geral',
        reports: 'Relatórios',
        stats: 'Estatísticas',
        shareInfo: 'Informação de acesso',
        floorPlan: 'Mapa da Planta',
        pictures: 'Fotos',
        location: 'Localização',
        organisation: 'Organização',
        version: 'Versão',
        status: 'Estado',
        batteryStatus: 'Estado da bateria',
        share: 'Partilhar',
        actions: 'Ações',
        noDevicesAdded: 'Não foram acrescentados novos dispositivos ao local',
        devicesOnLocation: 'Dispositivos neste local',
        noDevicesSetupYet:
            'Ainda não foram instalados quaisquer dispositivos neste local.',
        nameCanNotBeEmpty: `O nome não pode estar vazio`,
        address: 'Endereço',
        parentLocation: 'Local principal',
        noParentLocation: 'Sem local principal',
        locationNotFound: 'Localização não encontrada',
        deviceName: 'Nome do dispositivo',
        deviceSerial: 'Número de série do dispositivo',
        event: 'Evento',
        time: 'Hora',
        reportsOnLocation: 'Relatórios sobre o local',
        noReportsOnLocation: 'Ainda não há relatórios neste local',
        locationStatistics: 'Estatísticas do local',
        noLocationStatistics: 'Ainda não há estatísticas para este local',
        locationNotShared:
            'Este local não é partilhado com nenhum outro utilizador',
        sureRevokeShareAccessLocation:
            'Tem a certeza de querer revogar o acesso a este utilizador?',
        devicesAmount: 'Quantidade de dispositivos',
        noDevicesToAddFound:
            'Não foram encontrados quaisquer dispositivos a acrescentar.',
        deleteLocationsModalText:
            'Tem a certeza de que quer eliminar este local? Todos os locais iniciais também serão eliminados. Todos os dispositivos serão movidos para o armazenamento. Continuar?',
        dragNDropInfo: `Arraste 'n' aqui alguns ficheiros, ou clique para seleccionar ficheiros`,
        dragNDropFiles: '(Pode carregar ficheiros png, jpeg e pdf)',
        deleteFloorPlanModal:
            'Tem a certeza de que quer apagar o o mapa da planta?',
        toDeleteFloorPlanTypeIn:
            'Para eliminar o mapa do plano, por favor escreva este número:',
        goToDevice: 'Ir para o dispositivo',
        removeFromFloorPlan: 'Remover do mapa da planta',
        noFloorPlan: 'Não há planta baixa para este local',
        addFloorPlan: 'Carregar planta baixa',
        addDevice: 'Adicionar um Dispositivo',
        addNewDevice: 'Adicionar um novo dispositivo',
        devicesInThisLocation: 'Dispositivos neste local',
        floorPlanBtns: {
            appearance: 'Aparência',
            actions: 'Ações',
            add: 'Adicionar dispositivos',
            allFilters: 'Filtros',
            filter: 'Dispositivos de filtragem',
            delete: 'Apagar planta baixa',
            replace: 'Substituir planta baixa',
            serialLabel: 'Números de série',
            nameLabel: 'Nome do Dispositivo'
        },
        locationsPath: 'Caminho de localização',
        locationId: 'ID do local',
        newLocation: '- Nova localização -',
        responsible: 'Responsável',
        onlyResponsibleLocations: 'Destacar os meus locais (na árvore)',
        unlockMarkers: 'Desbloquear marcadores',
        lockMarkers: 'Marcadores de bloqueio',
        responsibleTooltip:
            'Os locais pelos quais é responsável serão marcados com um pequeno ponto azul',
        addResponsible: 'Acrescentar responsável',
        add: 'Acrescentar',
        scanWithQr: 'Scan',
        allLocations: 'Todos',
        myLocations: 'Os meus locais',
        userSearchError: 'Ocorreu um erro durante a pesquisa de utilizadores',
        getResponsiblesError:
            'Ocorreu um erro durante o carregamento ou carregamento para este local',
        addResponsibleError:
            'Ocorreu um erro ao tentar adicionar o responsável',
        deleteResponsibleError: 'Ocorreu um erro ao eliminar o responsável',
        getResponsibleLocationsError:
            'Ocorreu um erro durante o carregamento de locais para o utilizador responsável',
        userNotFound: 'Utilizador não encontrado...',
        noLocationsForResponsible:
            'Por favor, definir utilizadores responsáveis na visão geral de localização para que os locais apareçam aqui.',
        assign: 'Atribuir',
        contact: 'Pessoa de contacto',
        locationEmail: 'Email de localização',
        locationDetails: 'Detalhes de localização (Opcional)',
        contactPhone: 'Telefone de localização',
        noFloorplan: 'Ainda não foi carregada planta baixa',
        selectFile: 'Seleccione um ficheiro ou largue o ficheiro aqui',
        uploadFloorplan: 'Carregar planta baixa',
        editFloorplan: 'Editar Planta Baixa',
        crop: 'Cortar',
        rotate: 'Rodar',
        save: 'Guardar',
        somethingWentWrong: 'Alguma coisa correu mal',
        heatmap: 'Heatmap',
        escalationLevels: 'Níveis de escalonamento',
        level: 'Nível',
        sendAutomaticallyTriggered: 'Enviar E-Mails automaticamente',
        days: 'Dias',
        hours: 'Horas',
        afterTrapStatus:
            'Depois de a armadilha ter recebido o seu estado e o estado não ter sido alterado',
        afterTheTrapTriggered:
            'depois de a armadilha ter sido activada e o estado não ter sido alterado',
        eMailOfRecipient: 'E-Mail do destinatário',
        addLevel: 'Adicionar nível',
        escalationModalSubTitle:
            'A mensagem será adicionada ao e-mail juntamente com as informações do dispositivo e a imagem da planta baixa',
        locationsWithoutAddressLabel:
            'Os seguintes locais não têm endereço, por favor guarde o endereço para esses locais:',
        locationsWithoutAddressAndWithoutCoordsLabel:
            'Os seguintes locais têm endereço mas não podem ser apresentados no mapa porque o endereço não foi encontrado no mapa',
        floorPlanPinCaution:
            'Recomendamos reiniciar o dispositivo se o moveu para um novo local',
        showCompletedTasks: 'Mostrar tarefas concluídas',
        hideCompletedTasks: 'Ocultar tarefas concluídas',
        tasksAtThisLocation: 'Tarefas neste local',
        createNewTask: 'Criar nova tarefa',
        tasks: 'Tarefas',
        tasksFetchFail: 'Falha ao buscar tarefas',
        taskCreated: 'Tarefa criada com sucesso',
        taskCreateFail: 'Falha ao criar tarefa',
        taskUpdated: 'Tarefa atualizada com sucesso',
        taskUpdateFail: 'Falha ao atualizar tarefa',
        taskDescriptionTooLong:
            'A descrição da tarefa é muito longa, máximo de 1024 caracteres permitidos',
        includeSubLocations: 'Incluir sub localizações',
        last30Days: 'Últimos 30 dias',
        last7Days: 'Últimos 7 dias',
        clickOnThePFM: 'Clique no ponto para mais informações',
        reportsAmount: 'Quantidade de relatórios',
        settingsAndActions: 'Configurações e ações',
        locationSettings: 'Configurações de localização',
        locationActions: 'Ações de localização',
        baitSettings: 'Configurações de Jerry Bait',
        successWithAmountOfUpdatedDevices:
            'Sucesso! Quantidade de dispositivos atualizados:',
        settingsAndActionsAreAppliedToAll:
            'As configurações e ações baseadas em localização são aplicadas a todos os dispositivos nesta localização.',
        settingsAndActionsAreNotAppliedToSL:
            'As configurações e ações não são aplicadas a sublocalizações e dispositivos em sublocalizações.',
        noSettingsConfiguredYet:
            'Ainda não há configurações definidas para esta localização.',
        selectSettingType: 'Selecione o tipo de configuração',
        areYouSureYouWantToRemoveThisSetting:
            'Tem certeza de que deseja remover esta configuração?',
        resetTheActivityThreshold: 'Redefinir o limite de atividade',
        resetTheActivityThresholdDescr:
            'Redefinir o limite de atividade limpa a contagem de atividades para o período selecionado',
        locationBasedSettingsAndActions:
            'Configurações e ações baseadas em localização',
        lBasedConfirmReplaceBaitQuestion:
            'Ao confirmar isto, definirá a data da última substituição de isca para todos os dispositivos nesta localização.',
        lBasedConfirmThresholdResetQuestion:
            'Ao confirmar isto, redefinirá as atividades para todos os dispositivos nesta localização. Um novo limite será definido e as atividades serão redefinidas para o período selecionado.',
        lBasedSettingsAreAppliedYouCanNotEdit:
            'Os valores de peso do isco e de atividade são definidos pela localização. Abra as configurações da localização para os alterar.',
        lBasedSettingsAreApplied:
            'Os valores de peso do isco e de atividade são definidos pela localização.',
        confirmPowerOffDescr:
            "Isto confirma que desligou todos os dispositivos nesta localização e define o estado dos dispositivos como 'Inativo'.",
        switchMMModeOnDescr:
            'Ativa o modo de manutenção para todos os dispositivos nesta localização. No modo de manutenção, o dispositivo não altera o seu estado, não são criados relatórios e não são enviadas notificações.',
        switchMMModeOffDescr:
            'Desativa o modo de manutenção para todos os dispositivos nesta localização.',
        confirmMMModeOnDescr:
            'O modo de manutenção será ativado para todos os dispositivos nesta localização. No modo de manutenção, o dispositivo não altera o seu estado, não são criados relatórios e não são enviadas notificações.',
        confirmMMModeOffDescr:
            'O modo de manutenção será desativado para todos os dispositivos nesta localização.'
    },
    devices: {
        noDeviceMoveHistoryMsg:
            'Não há histórico de movimentação para este dispositivo.',
        getDeviceMoveHistoryEx:
            'Ocorreu um erro ao carregar o histórico de movimentação do dispositivo',
        assigned: 'Atribuído',
        allDevices: 'Todos',
        details: 'Detalhes',
        devices: 'Dispositivos',
        location: 'Localização',
        organisation: 'Organização',
        version: 'Versão',
        serialNr: 'Número de série',
        name: 'Nome',
        deviceSerial: 'Número de série do dispositivo',
        description: 'Descrição',
        operationModeLabel: 'Modo de operação',
        heartbeatCount: 'Contagem de sinal de comunicação',
        mode: 'Modo',
        status: 'Estado',
        batteryStatus: 'Estado da bateria',
        actions: 'Ações',
        noDevicesSetup: 'Não foram criados dispositivos',
        noUserFromAnotherOrg:
            'Ainda não há nenhum utilizador de outra organização.',
        pleseAddUserFromAnotherOrg:
            'Por favor, acrescente um utilizador de outra organização.',
        inUserMgmt: 'em Gestão de Utilizadores',
        chooseUserToShareWith:
            'Por favor escolha um utilizador para partilhar com',
        macAddress: 'Endereço MAC',
        battery: 'Bateria',
        deviceIsNotFound: 'Dispositivo não encontrado',
        nameIsTooShort: 'O nome é demasiado curto',
        reset: 'Restabelecer valores de fábrica',
        resetTomStatus: 'Restabelecer o status',
        reportCatch: 'Informar captura',
        setOffline: 'Confirmar desligamento de energia',
        heartbeatInterval: 'Intervalo do sinal de comunicação',
        occupancyRate: 'Taxa de ocupação',
        triggerCount: 'Contagem de disparos',
        triggeredSince: 'Disparado desde',
        catchCount: 'Contagem de capturas',
        traps: 'Armadilhas',
        noReportsNow: 'Actualmente não existem relatórios para',
        noReportsForRange:
            'Para este intervalo de tempo não há relatórios para',
        noReportsYet: 'Ainda não existem relatórios',
        resetDescr:
            'As estatísticas anteriores para este dispositivo serão eliminadas. Além disso, as seguintes configurações serão repostas: Nome, Descrição, Intervalo de batimentos cardíacos. O dispositivo será definido para o estado "Inactivo".',
        resetDescrNote: `Note-se que terá de reiniciar a bateria separadamente.`,
        reportCatchDescr: `Tem a certeza de que quer denunciar uma captura?`,
        reportCatchSelectReport:
            'Para qual dos seguintes relatórios pretende criar um relatório de capturas?',
        setOfflineDescr: `Isto confirma que desligou este dispositivo no local. O dispositivo fica com o estatuto de 'Inactivo'.`,
        resetBatteryDescr: `Isto confirma que substituiu as baterias deste dispositivo no local. O contador de baterias será reposto a 100%.`,
        resetBattery: `Confirmar mudança de bateria`,
        resetTOMStatusDescr: `O estado deste dispositivo TOM será restabelecido para 'Online '.`,
        online: 'Dispositivos online',
        stock: 'Offline',
        warning: 'Avisos',
        error: 'Crítico',
        filters: {
            warning: 'Avisos',
            info: 'Dispositivos em linha',
            inactive: 'Offline',
            critical: 'Crítico'
        },
        qrCode: 'Código QR',
        serialEmptyError: 'Dispositivo sem número de série',
        catchDescription: 'Descrição da captura',
        catchDescriptionMessage:
            'Aqui pode acrescentar uma descrição para a captura',
        wifiSetSuccess: 'Credenciais de WiFi definidas com sucesso',
        wifiSetFail: 'Falha ao definir as credenciais de WiFi',
        wifiSSID: 'SSID do WiFi',
        wifiPassword: 'Senha do WiFi',
        wifiPasswordMinLengthError: 'Deve ser mais longo',
        wifiSSIDMinLengthError: 'Não pode estar vazio',
        wifiSignalStrength: 'Intensidade de sinal',
        wifiSignalStrengthHover: 'Com base no último Batimento Cardíaco',
        wifiExcellent: 'Muito bom',
        wifiGood: 'Bom',
        wifiLow: 'Baixo',
        wifiBad: 'Mau',
        wifiUnknown: 'Desconhecido',
        operationMode: {
            movement: 'Movimento',
            snaptrap: 'Snaptrap',
            insect: 'Inseto',
            bait: 'Isca'
        },
        operationModeInsect: 'Inseto',
        tom: 'TOM',
        jerry: 'JERRY',
        deviceTypes: {
            tom: 'TOM',
            jerry: 'JERRY',
            'jerry-lora': 'JERRY-Lora',
            'tm01-1': 'TrapMe',
            trapsensor: 'TrapSensor',
            'jerry-bait-rat': 'JERRY-Bait-Rat'
        },
        deviceOperationMode: 'Modo de funcionamento',
        deviceType: 'Tipo de dispositivo',
        routerType: 'Tipo de router',
        insectModeTooltip: 'Este dispositivo está a funcionar em modo insecto',
        snaptrapModeTooltip:
            'Este dispositivo está a funcionar em modo snaptrap',
        movementModeTooltip:
            'Este dispositivo está a funcionar em modo de movimento',
        baitModeTooltip: 'Este dispositivo está a funcionar em modo de isca',
        rearmed: 'Rearmado',
        inactive: 'Inactivo',
        deviceIsInactive: 'O dispositivo está inactivo.',
        deviceStatuses: {
            0: 'Inativo',
            1: 'Activo',
            2: 'Sinal de comunicação perdido',
            3: 'Ativado',
            4: 'Bateria fraca',
            5: 'Localizar e ligar',
            6: 'Ligação instável',
            7: 'Ligeiramente Infestado',
            8: 'Muito infestado',
            9: 'Ativação falsa',
            10: 'Actividade (Aviso)',
            11: 'Actividade (Crítica)'
        },
        deviceStatusDescription: {
            0: 'O dispositivo está inactivo.',
            1: 'O dispositivo está online e a funcionar normalmente.',
            2: 'Parece haver problemas de ligação: A ligação wifi na posição deste dispositivo parece não ser fiável.',
            3: 'Foi accionada uma armadilha de disparo que requer uma inspecção manual.',
            4: 'O nível da bateria deste dispositivo é baixo. É favor mudar as pilhas.',
            5: 'O dispositivo está em modo BEACON e pode ser localizado.',
            6: 'Parece haver problemas de ligação: A ligação wifi na posição deste dispositivo parece não ser fiável.',
            7: 'Um utilizador relatou uma infestação ligeira para este dispositivo.',
            8: 'Um utilizador relatou uma infestação pesada para este dispositivo.',
            9: 'Um utilizador relatou um falso disparo de uma armadilha de disparo para este dispositivo.',
            10: 'Um utilizador reportou actividade neste dispositivo.',
            11: 'Um utilizador relatou actividade crítica neste dispositivo.'
        },
        deviceStatusShortDescription: {
            0: 'Inactive',
            1: 'Activo',
            2: 'Sinal de comunicação perdido',
            3: 'Ativado',
            4: 'Bateria fraca',
            5: 'Localizar e ligar',
            6: 'Ligação instável',
            7: 'Ligeiramente Infestado',
            8: 'Muito infestado',
            9: 'Ativação falsa',
            10: 'Actividade (Aviso)',
            11: 'Actividade (Crítica)'
        },
        deviceLastReportTypeShortDescription: {
            0: 'Online', // successfully_set_up
            1: 'Online', // restarted
            2: 'Disparado',
            3: 'Online', // rearmed
            '3-bait': 'Isco disponível',
            4: 'Sinal de comunicação perdido',
            5: 'Para baixo',
            6: 'Localizar e ligar',
            11: 'Online', // online_again
            12: 'Inactive',
            13: 'Ligação instável',
            15: 'Ligeiramente Infestado',
            16: 'Heavily Infestado',
            17: 'Fortemente desencadeamento',
            18: 'Actividade (Advertência)',
            19: 'Actividade (Crítica)',
            20: 'Captura',
            21: 'Atividade detectada',
            22: 'Limiar de atividade atingido',
            23: 'Isca baixa',
            24: 'Limiar de atividade atingido e isca baixa',
            25: 'Limiar de atividade redefinido'
        },
        changeOperationMode: `Escolheu um modo diferente. Para aplicar a alteração por favor desligue e volte a ligar o seu dispositivo TOM.`,
        pestControlSystemLabel: 'Sistema de controlo de pragas',
        pestControlSystemNotSelected: 'Não seleccionado',
        pestControlSystems: {
            1: 'AF-Box (Rato)',
            2: 'nagtag (Camundongo)',
            3: 'nagtag (Rato)',
            4: 'Túnel Metálico (Rato)',
            5: 'SpeedBreak (Camundongo)',
            6: 'GSG (Camundongo)',
            7: 'Suporte Flexível',
            8: 'Detector de Baratas Heisenberg',
            9: 'Armadilha de Funil para Mariposas Agrisense',
            10: 'Armadilha UV para Moscas (qualquer)',
            11: 'GSG (Rato)'
        },
        deviceActions: 'Acções de dispositivos',
        serialNumberSearchModal: {
            header: 'Buscar a lista de números de série',
            subHeader:
                'Aqui você pode colar a lista de números de série dos dispositivos, com cada número de série em uma nova linha, da seguinte forma:',
            placeHolder: 'Números de série'
        },
        tableConfigurationModal: {
            header: 'Configurar colunas da tabela',
            subHeaderMainly: 'Principalmente utilizado',
            subHeaderAdditional: 'Adicional'
        },
        moveDevicesModal: {
            header: {
                1: 'Para onde deve ser movido?',
                2: 'Mover dispositivo(s) para a localização'
            },
            totalNumber: 'Número total:'
        },
        configureTableLabel: 'Configurar tabela',
        history: 'História',
        move: 'Mover',
        pestControlSystem: 'Sistema',
        transferMode: 'Modo de transferência',
        cellular: 'Móvel',
        connectedGateway: 'Gateway LoRa',
        gatewayNotFound: 'Gateway não encontrado',
        gatewayLastSignal: 'Último sinal',
        notAssigned: 'Não atribuído',
        moveDToL: 'Mover dispositivos para localização',
        youAreNotAbleToMoveTheseDevices:
            'Você não pode mover estes dispositivos porque as localizações em que eles estão não estão atribuídas a você ou você tem apenas acesso de leitura para estes. Por favor, verifique seu papel ou entre em contato com o gerente da sua organização.',
        devicesAmount: 'Quantidade de dispositivos',
        noDevicesYouCanMove:
            'Não há dispositivos que você possa mover para outra localização a partir dos que selecionou',
        devicesReadyToMove:
            'Estes dispositivos estão prontos para serem movidos.',
        devicesSelected: 'Selecionados',
        moveToLocation: 'Mover para localização',
        delete: 'Excluir',
        youAreNotAbleToDeleteTheseDevices:
            'Você não pode excluir estes dispositivos porque as localizações em que eles estão não estão atribuídas a você ou você não tem permissões de exclusão para estes. Por favor, verifique seu papel ou entre em contato com o gerente da sua organização.',
        devicesRemovedFromOrg:
            'Os dispositivos foram removidos da organização com sucesso',
        deleteDevicesFromOrg: 'Excluir dispositivos da sua organização',
        noDevicesYouCanDelete: 'Não há dispositivos que você possa excluir',
        devicesReadyToDelete:
            'Estes dispositivos estão prontos para serem excluídos.',
        areYouSureYouWantToDeleteDevices:
            'Tem certeza de que deseja excluir os dispositivos? Os dispositivos serão excluídos da sua conta e não serão mais visíveis na lista de dispositivos.',
        devicesSwitchedOffSuccessfully:
            'Os dispositivos foram desligados com sucesso',
        noDevicesYouCanSwitchOff:
            'Não há dispositivos para os quais você possa confirmar o desligamento',
        devicesReadyToSwitchOff:
            'Estes dispositivos estão prontos para serem desligados.',
        areYouSureYouWantToConfirmSwitchOff:
            'Tem certeza de que deseja confirmar o desligamento destes dispositivos? Isso confirma que você desligou os dispositivos no local. Os dispositivos receberão o status "Inativo"',
        devicesSwitchedOnMModeSuccessfully:
            'O modo de manutenção foi ativado com sucesso',
        noDevicesYouCanSwitchOnMMode:
            'Não há dispositivos para os quais você possa ativar o modo de manutenção',
        forTheseDevicesYouCanSwitchOnMMode:
            'Para estes dispositivos você pode ativar o modo de manutenção.',
        areYouSureYouWantToConfirmSwitchOnMMode:
            'Tem certeza de que deseja ativar o modo de manutenção para estes dispositivos? No modo de manutenção, relatórios não são criados e notificações não são enviadas.',
        youAreNotAbleToSwitchOffTheseDevices:
            'Você não pode desligar estes dispositivos porque as localizações em que eles estão não estão atribuídas a você ou você não tem permissões de atualização para estes. Por favor, verifique seu papel ou entre em contato com o gerente da sua organização.',
        youAreNotAbleToSwitchOnMModeTheseDevices:
            'Você não pode ativar o modo de manutenção para estes dispositivos porque as localizações em que eles estão não estão atribuídas a você ou você não tem permissões de atualização para estes. Por favor, verifique seu papel ou entre em contato com o gerente da sua organização.',
        areYouSureConfirmReplacementOfBait:
            'Tem certeza de que deseja confirmar a substituição da isca?',
        areYouSureYouWantToResetTheActivityThreshold:
            'Tem certeza de que deseja redefinir o limite de atividade?',
        baitMonitoring: 'Monitoramento de isca',
        enablesOrDisablesBaitWeightTracking:
            'Ativa ou desativa o monitoramento de isca',
        activityAlertThreshold: 'Limite de atividade',
        whenTheNotificationAlertShouldBeTriggered:
            'Com quantas atividades deseja receber uma notificação?',
        per: 'por',
        hours: 'horas',
        days: 'dias',
        baitType: 'Tipo de isca',
        whichBaitAreYouUsing: 'Qual isca / peso está a utilizar?',
        calibration: 'Limite de isca',
        notifiedWhenBaitWeightLowerThan:
            'Para que peso foi calibrada a plataforma de isca? Com este peso residual receberá uma notificação.',
        baitPad: 'Plataforma de isca',
        replaceBait: 'Confirmar substituição de isca',
        resetsTheBaitStatusToAvailable:
            'Define a hora da última substituição de isca',
        lastReplacement: 'Última substituição de isca',
        baitLowCount: 'Quantidade total de consumo de isca',
        activityCount: 'Quantidade total de atividades',
        activitiesThreshold: 'Limite de atividade',
        last: 'último/última',
        lastThresholdReset: 'Última redefinição do limite de atividade',
        activities: 'Atividades',
        activitiesSummary: 'Resumo de atividades',
        trackActivitiesInsights: 'Resumo das atividades',
        bait: 'Isca',
        baitAvailable: 'Isca disponível',
        baitLow: 'Nível de isca baixo',
        baitStatusDebounceInfo:
            'Os estados «Nível de isca baixo» e «Isca disponível» só são atualizados após {{minutes}} minutos sem movimento detetado na plataforma de isca. Ao configurar o dispositivo, ative o <bold>Modo de manutenção</bold> para que o estado seja apresentado em tempo real.',
        manufacturerAndType: 'Fabricante / Tipo',
        overrideLocationSettings:
            'Utilizar valores de monitorização separados para este dispositivo',
        overrideLocationSettingsDescription:
            'Ative esta opção se este dispositivo precisar de valores de peso do isco ou de atividade diferentes dos outros dispositivos nesta localização. Estes valores permanecem ativos até desativar esta opção ou repor o dispositivo.',
        deviceSettingsSource: 'Utiliza as configurações do dispositivo',
        monitoringValuesSetForLocation: 'Utiliza as configurações de',
        baitAndActivitySettings: 'Configurações de isco e atividade',
        locationSettingsOverrideMoveWarningTitle:
            'Manter configurações separadas?',
        locationSettingsOverrideMoveWarningText:
            'Um ou mais dispositivos selecionados têm as suas próprias configurações de peso do isco ou de atividade. Após a mudança, estas configurações permanecem nos dispositivos. As configurações da nova localização não serão aplicadas.',
        locationSettingsOverrideMoveConfirm: 'Mover e manter configurações'
    },
    simCards: {
        simCard: 'Cartão SIM',
        simCardSerialNumber: 'Número do cartão SIM',
        activate: 'Ativar',
        deactivate: 'Desativar',
        addSimCardLabel: 'Adicionar cartão SIM',
        addSimCardTooltipText:
            'Não há nenhum cartão SIM atribuído a este dispositivo de rede. Você pode adicioná-lo manualmente',
        simCardEmptyError: 'Não pode estar vazio',
        simCardNotValidIccidError: 'Formato numero do cartão SIM inválido',
        pendingStatusText:
            'O status do cartão SIM está sendo alterado, isso pode levar até 5 minutos',
        standByStatusText:
            'O cartão SIM está aguardando para transmitir dados e se tornará ativo assim que o fizer',
        billingDetails: {
            totalSimCardsText: 'Geactiveerde netwerkapparaten',
            totalSimCardsTextItalic: '(Huidige maand)',
            billing: 'Facturatie',
            tooltipText:
                'Het bedrag wordt automatisch van uw account afgeschreven op de laatste dag van elke maand',
            currencySymbol: '€'
        }
    },
    reports: {
        sentAutomatically: 'Enviado automaticamente',
        noSharingHistory: 'Não há histórico de partilha',
        sharingHistory: 'Histórico de partilha',
        sharedBy: 'por',
        toEmails: 'para',
        ccEmails: 'CC',
        filterFrom: 'a',
        filterTo: 'para',
        allReports: 'Todos',
        reports: 'Relatórios',
        deviceName: 'Nome do dispositivo',
        deviceSerial: 'Dispositivo em série',
        event: 'Evento',
        time: 'Hora',
        location: 'Localização',
        organisation: 'Organização',
        status: 'Estado',
        type: 'Tipo',
        share: 'Partilhar',
        sendMessage: 'Enviar mensagem',
        message: 'Mensagem',
        cancle: 'Cancelar',
        send: 'Enviar',
        sendReport: 'Enviar Relatório',
        emailSentSuccess: 'E-mail enviado com sucesso',
        emailSentFail: 'Ao contrário, algo correu mal',
        on: ' em ',
        sentAt: 'Enviado em: ',
        failToSend: 'Não enviou: ',
        mailMessageBegin: 'Caro Senhor ou Senhora,',
        mailMessageMainSection: 'Detectámos um gatilho da armadilha ',
        mailMessageMainSection2: '',
        mailMessageMainSection3:
            'Por favor, verifique a armadilha para apanhar em breve.',
        mailMessageEnd: 'Com os melhores cumprimentos ',
        mailMessageEnd2: 'FA. Fleschhut',
        noReportsYet: 'Ainda não há relatórios',
        noReportsForRange:
            'Para este intervalo de tempo não há relatórios para',
        reportTime: 'Hora do relatório',
        evaluationTime: 'Tempo de avaliação',
        reportTypes: {
            0: 'Criado com sucesso',
            1: 'Reiniciado',
            2: 'Disparado',
            3: 'Armado',
            '3-bait': 'Isco disponível',
            4: 'Sinal de comunicação perdido',
            5: 'Caiu',
            6: 'Localizar agora',
            7: 'Localização de falhas',
            8: 'Definições updated',
            9: 'Actualização bem sucedida',
            10: 'Bateria fraca',
            11: 'Novamente online',
            12: 'Desligado',
            13: 'Ligação instável',
            14: 'Infestado',
            15: 'Ligeiramente infestado',
            16: 'Muito infestado',
            17: 'Falso desencadeamento',
            18: 'Actividade (Advertência)',
            19: 'Actividade (Crítico)',
            20: 'Captura',
            21: 'Atividade detectada',
            22: 'Limiar de atividade atingido',
            23: 'Isca baixa',
            24: 'Limiar de atividade atingido e isca baixa',
            25: 'Limiar de atividade redefinido'
        },
        reportTypesDescription: {
            0: 'O dispositivo foi reiniciado e os novos dados Wifi foram transferidos com sucesso.',
            1: 'O dispositivo foi reiniciado.',
            2: 'Foi accionada uma armadilha de disparo que requer uma inspecção manual.',
            3: 'As armadilhas de captura estão armadas e o dispositivo está pronto para a próxima captura.',
            '3-bait': 'Existe isco disponível na placa de isco.',
            4: 'Pode haver problemas de ligação: O dispositivo não conseguiu chegar ao servidor durante o intervalo de batimento cardíaco escolhido.',
            5: 'Existem problemas de ligação: O dispositivo não foi capaz de chegar ao servidor durante um período de tempo prolongado e requer verificação manual da localização.',
            6: 'O dispositivo está em modo BEACON e pode ser localizado',
            7: 'The device couldnât initiate beacon mode',
            8: 'As definições do dispositivo (por exemplo, intervalo de batimento cardíaco ou/e modo de funcionamento) foram alteradas.',
            9: 'Foi feita com sucesso uma actualização de firmware para o dispositivo.',
            10: 'O nível da bateria deste dispositivo é baixo. É favor mudar as pilhas.',
            11: 'O dispositivo está de novo online, não há mais problemas de ligação.',
            12: 'O dispositivo foi desligado.',
            13: 'Parece haver problemas de ligação: A ligação na posição deste dispositivo parece não ser fiável.',
            14: 'Um utilizador reportou uma infestação (captura) para este dispositivo.',
            15: 'Um utilizador relatou uma infestação ligeira para este dispositivo.',
            16: 'Um utilizador relatou uma infestação pesada para este dispositivo.',
            17: 'Foi comunicada uma falsa ativação para este dispositivo.',
            18: 'Um utilizador reportou actividade neste dispositivo.',
            19: 'Um utilizador relatou actividade crítica neste dispositivo.',
            20: 'Foi detectada uma captura. É necessário um controlo manual.',
            21: 'Uma atividade foi detectada',
            22: 'O limiar de atividade definido foi atingido',
            23: 'O nível de isca está baixo',
            24: 'O limiar de atividade definido foi atingido e o nível de isca está baixo',
            25: 'O limiar de atividade foi redefinido manualmente'
        },
        info: 'Info',
        warning: 'Advertência',
        critical: 'Crítico',
        infested: 'Infestado',
        infestedDescription: 'Mostrar eventos de infestação',
        catch: 'Captura',
        triggered: 'Acionado',
        triggeredDescription: 'Mostrar os eventos acionados',
        connectivity: 'Conectividade',
        connectivityDescription: 'Mostrar a conectividade por dispositivo',
        catchDescription: 'Descrição da captura',
        settings: 'Configurações',
        at: ' às ',
        comments: 'Comentários',
        edit: 'Editar',
        delete: 'Eliminar',
        save: 'Guardar',
        deleteConfirmation: 'Tem a certeza de que quer eliminar comentários?',
        addComment: '+ Adicionar comentário',
        commentsAvailable: 'Há comentários para este relatório',
        enterCommentPlaceholder: 'Comentar...',
        commentEmptyEx: 'Por favor, introduza um comentário',
        somethingWentWrong:
            'Algo correu mal ao capturar capturas de ecrãs da planta do chão',
        exportDenyMsg:
            'Por favor seleccione o intervalo de tempo para a exportação de menos de 3 meses. Pode definir em filtros. O intervalo de tempo actual é demasiado grande para a exportação.',
        changeRTToFT: 'Alterar tipo de relatório para ativação falsa',
        changeRTToFTDescr:
            'A armadilha está vazia? Por favor, adicione um comentário e opcionalmente uma foto da armadilha. Após a confirmação, este relatório de captura será alterado para relatório de ativação falsa',
        changeRTToCatch: 'Alterar tipo de relatório para captura',
        changeRTToCatchDescr:
            'Há uma captura na armadilha? Por favor, adicione um comentário e opcionalmente uma foto da armadilha. Após a confirmação, este relatório de ativação falsa será alterado para relatório de captura'
    },
    userManagement: {
        userManagement: 'Gestão de utilizadores',
        users: 'Utilizadores',
        roles: 'Papéis',
        roleName: 'Nome da Função',
        customer: 'Organização',
        actions: 'Actions',
        createNew: 'Criar novo',
        addFromAnotherOrg: 'Adicionar de outra organização',
        noUsersFound: 'Nenhum utilizador encontrado',
        emailIsEmpty: 'O e-mail está vazio',
        isNotEmail: ' não é um e-mail',
        fillInEmail:
            'Por favor, preencha o e-mail do utilizador de outra organização.',
        onlyToYourOrg:
            'Só é possível acrescentar um utilizador à sua organização',
        chooseRole: 'Por favor escolha uma função para o utilizador',
        verify: 'Verifiquem',
        add: 'Add',
        whichOrgToCreateUser:
            'Em que organização pretende criar um utilizador?',
        create: 'Criar',
        pickOrgToDeleteUser:
            'Por favor escolha a organização de onde pretende eliminar o utilizador',
        sureDeleteUser: 'Tem a certeza de que quer eliminar este utilizador?',
        sureDeleteUsers:
            'Tem a certeza de que quer eliminar estes utilizadores?',
        nameIsTooShort: 'O nome é demasiado curto',
        emailIsNotCorrect: 'O e-mail não está correcto',
        genPassword: 'Gerar palavra-passe',
        changePassword: 'Alterar palavra-passe',
        noRolesFound: 'Não foram encontrados papéis',
        component: 'Componente',
        read: 'Leia',
        update: 'Actualização',
        delete: 'Excluir',
        roleNotFound: 'A Função não foi encontrada',
        defaultRoles: {
            [DEFAULT_ROLES.traplinked_admin]: 'traplinked admin',
            [DEFAULT_ROLES.customer_admin]: 'Administração da organização',
            [DEFAULT_ROLES.viewer]: 'Visualizador',
            [DEFAULT_ROLES.management_user]: 'Utilizador de gestão',
            [DEFAULT_ROLES.read_only_user]: 'Utilizador apenas de leitura',
            [DEFAULT_ROLES.location_management_user]:
                'Utilizador de gestão de localização',
            [DEFAULT_ROLES.technician]: 'Técnico'
        },
        youCanNotDeleteThisUser: 'Não se pode apagar este utilizador',
        youCanNotDeleteThisRole: 'Não é possível eliminar esta função',
        internalUser: 'Utilizador interno',
        externalUser: 'Utilizador externo',
        createUserModalTitle: 'Criar novo utilizador',
        createExternalTitle: 'Criar utilizador externo',
        createInternalTitle: 'Criar utilizador interno',
        userRalationStepTitle: 'Escolher relação de utilizador',
        credentialsStepTitle: 'Login e Palavra-passe',
        createRoleStepTitle: 'Criar função personalizado',
        selectRoleStepTitle: 'Escolher função para o utilizador',
        selectLocationsStepTitle: 'Escolher locais',
        reviewStepTitle: 'Revisão final',
        nextStep: 'Próximo step',
        stepBack: 'Recuar',
        completeBtn: 'Completo',
        backToDefaultRoles: 'Voltar aos papéis por defeito',
        userRalationOptionName: {
            [USER_RELATIONS.internal]: 'Interno',
            [USER_RELATIONS.external]: 'Externo'
        },
        userRalationOptionDescription: {
            [USER_RELATIONS.internal]:
                'Nova conta de utilizador para uma pessoa que trabalha na sua organização, adequada para o seu empregado que ainda não tem conta no sistema traplinked',
            [USER_RELATIONS.external]:
                'Nova conta de utilizador/acesso à sua organização a partir de uma organização externa, contratantes adequados que ainda não possuem uma conta de utilizador ou que já possuem uma'
        },
        firstName: 'Primeiro nome',
        lastName: 'Apelido',
        password: 'Senha',
        customerName: 'Nome do cliente',
        userRelationExplanation: {
            [RELATIONS.internal]:
                'O utilizador com este e-mail já existe na sua empresa como interno',
            [RELATIONS.externalIn]:
                'O utilizador com este e-mail já existe na sua empresa como um utilizador externo',
            [RELATIONS.externalOut]:
                'Pode adicionar este utilizador à organização apenas como um utilizador externo. Deseja prosseguir?',
            [RELATIONS.nonexistent]: ''
        },
        roleNames: {
            [DEFAULT_ROLES.customer_admin]: 'Administrador',
            [DEFAULT_ROLES.viewer]: 'Visualizador',
            [DEFAULT_ROLES.management_user]: 'Gerente',
            [DEFAULT_ROLES.technician]: 'Técnico',
            [CUSTOM_ROLE]: 'Custom'
        },
        roleDescription: {
            [DEFAULT_ROLES.customer_admin]:
                'Âmbito total das permissões no sistema: pode gerir locais, dispositivos, utilizadores e outros',
            [DEFAULT_ROLES.viewer]:
                'Não tem acesso à gestão de utilizadores, só pode ler e visualizar os locais atribuídos, ver o estado dos dispositivos, relatórios a partir dos locais atribuídos',
            [DEFAULT_ROLES.management_user]:
                'Pode criar e gerir locais mas não os pode eliminar, pode gerir dispositivos, relatórios, pode gerir utilizadores mas não os pode eliminar',
            [DEFAULT_ROLES.technician]:
                'Não tem acesso à gestão de utilizadores, pode criar, gerir e apagar locais atribuídos, pode gerir dispositivos e relatórios de locais atribuídos',
            [CUSTOM_ROLE]: 'Papel personalizável'
        },
        createNewCustomrole: '+ Criar um novo Cargo Personalizado',
        selectExistingCustomRole: 'Selecionar papel personalizado',
        deselectAllLocations: 'Desmarcar todos',
        selectAllLocations: 'Seleccionar todos',
        showTheUserInTheList: 'mostrar o utilizador na lista',
        youCanProceedWithRoleSelection:
            'Pode prosseguir com a selecção de funções para este utilizador externo',
        sendInvitationMail: 'Enviar convite por correio electrónico',
        invitationModalText:
            'Tem a certeza de que pretende enviar o convite a este utilizador?',
        usersStillAssigned:
            'Os utilizadores continuam a ser atribuídos a essa função',
        usersAssignedTheRole:
            'Ainda existem utilizadores a quem foi atribuída a função que pretende eliminar',
        reassignThatUsers:
            'Reatribua a esse utilizador outra função antes de eliminar esta',
        deleteRoleConfirmation:
            'Tem a certeza de que pretende eliminar esta função?',
        reassignAndDeleteModal: {
            header: 'Usuários ainda estão atribuídos a essa função',
            textOne:
                'Ainda existem usuários atribuídos à função que você deseja excluir',
            textTwo:
                'Por favor, atribua outra função a esses usuários antes de excluir esta'
        }
    },
    sharing: {
        sharing: 'Partilha',
        chooseUsers: 'Escolha os utilizadores',
        chooseItems: 'Escolha itens para partilhar',
        confirmAndShare: 'Confirmar e partilhar',
        organisation: 'Organização',
        noUsersToShare:
            'Actualmente não há utilizadores adicionados de outra organização.',
        pleaseAddUsers: 'Por favor adicione utilizadores de outra organização',
        userMgmt: ' Gestão de utilizadores',
        noUsersLeft: 'Nenhum utilizador à esquerda para escolher',
        noUsersSelected: 'Nenhum utilizador seleccionado para partilha ainda',
        locations: 'Locais',
        devices: 'Dispositivos',
        reports: 'Relatórios',
        serialNr: 'Nº de série',
        noDevicesToShare: 'Actualmente não existem dispositivos para partilhar',
        noDevicesLeft: 'Sem dispositivos à esquerda para escolher',
        noDevicesSelected: 'Nenhum dispositivo seleccionado yet',
        noReportsToShare: 'Actualmente não há relatórios a partilhar',
        noReportsLeft: 'Não há mais relatórios à escolha',
        noReportsSelected: 'Ainda não foram seleccionados relatórios',
        address: 'Endereço',
        noLocationsToShare: 'Actualmente não existem locais para partilhar',
        contactSupport: 'Se vir esta mensagem, por favor contacte o apoio',
        noLocationsLeft: 'Não há mais locais à escolha',
        noLocationsSelected: 'Nenhum local seleccionado ainda',
        willBeSharedWith: 'Será partilhado com:',
        successShare: 'Partilhado com sucesso'
    },
    detachedSharing: {
        noDataToShare: 'Actualmente não há dados a partilhar',
        chooseUsers: 'Escolha os utilizadores',
        chooseItems: 'Escolha itens para partilhar',
        confirmAndShare: 'Confirmar e partilhar',
        noDevicesSetupYet:
            'Ainda não foram instalados quaisquer dispositivos neste local.',
        devicesSelected: 'Dispositivos seleccionados',
        locationsSelected: 'Locais seleccionados',
        selected: 'Selecionado',
        shareWithUsers: 'Partilhar com os utilizadores',
        existingFromAnotherOrg: 'acrescentado por outra organização',
        byEmailFromAnotherOrg: 'por e-mail',
        noUsersToShare:
            'Actualmente não há utilizadores adicionados de outra organização. Pode partilhar por correio electrónico.',
        usersSelected: 'Utilizadores seleccionados',
        plsTypeInEmail: 'Por favor escreva um endereço de e-mail válido',
        chooseRole: 'Por favor escolha uma função ',
        addUsersEmails: 'Adicionar endereço(s) de e-mail dos utilizadores',
        location: 'Localização',
        device: 'Dispositivo',
        serialNr: 'Nº de série',
        dataForSharing: 'Dados para partilha',
        willBeSharedWith: 'Será partilhada com',
        locationsPath: 'Caminho de localização',
        nothingFound: 'Nada foi encontrado'
    },
    settings: {
        faq: 'FAQ',
        language: 'Idioma',
        settings: 'Definições',
        logout: 'Fechar Sessão',
        emailNotificationsEnabled: 'Notificações por e-mail activadas',
        pushNotificationsEnabled: 'Notificações push activadas',
        smsNotificationsEnabled: 'Notificações por SMS activadas',
        trapsTriggeredNotificationsEnabled: 'O dispositivo foi accionado',
        trapsInactiveemailNotificationsEnabled: 'O dispositivo foi abaixo',
        batteryEmptyNotificationsEnabled: 'O dispositivo tem bateria fraca',
        batterySetupNotificationsEnabled: 'O dispositivo foi criado',
        trapOnlineNotificationsEnabled: 'O dispositivo está novamente online',
        unstableConnectionNotificationsEnabled:
            'O dispositivo tem conexão instável',
        baitLowNotificationsEnabled: 'O dispositivo tem nível de isca baixo',
        activityThresholdReachedNotificationsEnabled:
            'O dispositivo atingiu o limite de atividade',
        baitLowAndActivityThresholdReachedNotificationsEnabled:
            'O dispositivo tem nível de isca baixo e atingiu o limite de atividade',
        acceptSharedData: 'Actualização de dados partilhados',
        notificationsChannels: 'Canais de notificação',
        notificationsEvents: 'Notificação de eventos',
        nameIsTooShort: 'O nome é demasiado curto',
        phoneNumberErr: 'O número de telefone não é válido',
        organisationPhoneNumberErr:
            'O número de telefone da organização não é válido',
        reportBug: 'Comunicar um erro',
        viewOurRoadmap: 'Ver o nosso roteiro',
        voteOnNewFeatures: 'Votar em novas funcionalidades',
        termsOfService: 'Termos do serviço',
        termsConditions: 'Termos e condições',
        privacyPolicy: 'Política de privacidade',
        simCards: 'Cartões SIM',
        billingPortal: 'Faturamento',
        portalError: 'Erro ao carregar o portal de faturamento da Stripe'
    },
    login: {
        emailIsRequired: 'O e-mail é necessário para iniciar a sessão',
        passwordIsRequired:
            'É necessária uma palavra-passe para iniciar sessão',
        forgotPassword: 'Esqueceu-se da palavra-passe?',
        signIn: 'Iniciar sessão',
        newInTraplinked: 'Novo cliente? Por favor, inscreva-se.'
    },
    twoFactor: {
        title: 'Autenticação de dois fatores',
        helperText:
            'Introduza o código de 6 dígitos que enviámos para o seu e-mail',
        verify: 'Verificar',
        backToLogin: 'Voltar ao início de sessão'
    },
    resetPassword: {
        resetPassword: 'Redefinir palavra-passe',
        backToLogin: 'Voltar para login',
        goToLogin: 'Ir para login',
        passwordIsTooShort: 'A palavra-passe é demasiado curta',
        passwordsDoNotMatch: 'As palavras-passe não coincidem'
    },
    register: {
        nameIsTooShort: 'O nome é demasiado curto',
        emailIsNotCorrect: 'O e-mail não está correcto',
        passwordIsTooShort: 'A palavra-passe é demasiado curta',
        passwordsDoNotMatch: 'As palavras-passe não coincidem',
        registerUser: 'Registar Utilizador',
        haveAlreadyUser: 'Já tem uma conta? Por favor, faça login.',
        pleaseEnterOrgName:
            'Por favor introduza o nome da sua organização, é necessário',
        orgName: 'Nome da organização',
        registerOrg: 'Organização do registo',
        everythingIsReady:
            'O seu novo utilizador e nova organização estão prontos, agora pode iniciar sessão',
        goToLogin: 'Ir para login',

        registerYourOrganization: 'Registar a sua organização',
        youAreAPestController:
            'É um controlador de pragas e pretende registar a sua organização',
        alreadyHaveAnAccount: 'Já tem uma conta?',
        login: 'Iniciar sessão',
        or: 'ou',
        joinAnExistingOrganization: 'Juntar-se a uma organização existente?',
        accessYourOrganization:
            'Se é um técnico ou um membro da equipa que pretende aceder à sua organização, peça ao seu administrador para o convidar.',
        notSureWhoYourAdmin:
            'Não tem a certeza de quem é o seu administrador ou está a ter problemas? Contacte a nossa equipa de apoio para obter assistência.'
    },
    apiKeys: {
        apiKeys: 'Chaves API',
        apiKey: 'Chave API',
        viewDocs: 'View REST docs',
        copied: 'Copiado',
        failedToCopy: 'Falha na cópia',
        createNew: 'Criar novo',
        expires: 'Expira',
        noApiKeysFound: 'Não foram encontradas chaves API',
        plsProvideDescr: 'Por favor forneça a descrição da chave API',
        deleteKeyDescr:
            'Se eliminar esta chave API, o acesso aos dados através desta chave API já não é possível. Tem a certeza de que quer apagar esta chave API?',
        viewKeyDescr:
            'Introduza a chave API no software de terceiros para que este possa exibir os dados do seu dispositivo. Se o fabricante oferecer uma função correspondente, também pode digitalizar o código QR para introduzir a chave API.'
    },
    integrations: {
        integrations: 'Integrações',
        documentationTools: 'Ferramentas de documentação',
        apiKeys: 'Chaves API',
        pestsoft: 'Pestsoft',
        debuxx: 'DEBUXX',
        pestscan: 'Pestscan',
        pestscanPcoId: 'Pestscan PCO ID',
        username: 'Nome de utilizador',
        enterPassword: 'Introduza a palavra-passe',
        credentialsRequired:
            'Introduza e guarde as credenciais para concluir a ligação.',
        pestscanPcoIdRequiredWhenEnabled:
            'O PCO ID é obrigatório quando o Pestscan está ativado.',
        debuxxHint: {
            toggle: 'Como obtenho estas credenciais?',
            title: 'Criar um utilizador API do DEBUXX',
            body: 'Os administradores podem criar um utilizador API no DEBUXX em **Einstellungen → Erweiterungen** escolhendo um nome de utilizador e uma palavra-passe. Copie-os para aqui para ligar.',
            support:
                'Continua a precisar de ajuda? Contacte o suporte do DEBUXX se tiver mais dúvidas sobre como criar ou obter estas credenciais.'
        },
        pestscanHint: {
            toggle: 'Como obtenho o meu PCO ID?',
            title: 'Criar um perfil PC40 no Pestscan',
            steps: {
                1: 'Aceda a **General Settings** através da roda dentada na barra de navegação principal.',
                2: 'Selecione **Permanent Monitoring** no menu.',
                3: 'Abra o separador **Profiles** e clique em **New**.',
                4: 'Defina **Description** com algo claro, por exemplo PC40.',
                5: 'Defina **Type** como PC40.',
                6: 'Clique em **Save**.',
                7: 'Copie o **PCO ID** resultante e cole-o aqui.'
            },
            support:
                'Continua a precisar de ajuda? Contacte o suporte do Pestscan se tiver mais dúvidas sobre como obter o seu PCO ID.'
        },
        settingsUpdated: 'Definições de integração atualizadas',
        settingsUpdateFailed: 'Falha ao atualizar as definições de integração',
        loadFailed: 'Falha ao carregar as definições de integração',
        summaryTitle: 'Visão geral de integrações e API',
        apiKeysCount: 'Chaves API',
        webhooks: 'Webhooks',
        webhooksTab: {
            title: 'Webhooks',
            viewDocs: 'Ver documentação dos webhooks',
            createWebhook: 'Criar webhook',
            editWebhook: 'Editar webhook',
            deleteWebhook: 'Eliminar webhook',
            confirmDeleteWebhook:
                'Isto eliminará o webhook permanentemente. Esta ação não pode ser desfeita.',
            noWebhooksFound: 'Ainda sem webhooks',
            emptyBody:
                'Os webhooks entregam eventos dos dispositivos em tempo real aos seus endpoints. Crie um para começar a receber dados.',
            editorSubtitle:
                'Os webhooks entregam eventos dos dispositivos em tempo real',
            webhookCreated: 'Webhook criado',
            webhookUpdated: 'Webhook atualizado',
            webhookDeleted: 'Webhook eliminado',
            createFailed: 'Falha ao criar o webhook',
            updateFailed: 'Falha ao atualizar o webhook',
            deleteFailed: 'Falha ao eliminar o webhook',
            loadFailed: 'Falha ao carregar os webhooks',
            statusEnabled: 'Ativo',
            statusDisabled: 'Inativo',
            saveChanges: 'Guardar alterações',
            cancel: 'Cancelar',
            never: '--',
            fields: {
                status: 'Estado',
                name: 'Nome',
                description: 'Descrição',
                endpoint: 'URL',
                webhookType: 'Tipo',
                requestMethod: 'Método',
                reasons: 'Tipos de relatório',
                reasonSingular: 'tipo de relatório',
                reasonPlural: 'tipos de relatório',
                reasonsTotalSuffix: 'disponíveis',
                isEnabled: 'Ativo',
                isEnabledHint:
                    'Quando ativo, são entregues os relatórios correspondentes aos tipos selecionados.',
                headers: 'Cabeçalhos',
                lastResponse: 'Última resposta',
                lastResponseCode: 'Código da última resposta',
                lastRequestTimestamp: 'Último pedido'
            },
            placeholders: {
                name: 'O meu webhook',
                endpoint: 'https://example.com/webhooks/traplinked',
                description: 'Para que serve este webhook?',
                reasonsEmpty: 'Selecione um ou mais tipos de relatório…'
            },
            headers: {
                keyHeader: 'Chave',
                valueHeader: 'Valor',
                keyPlaceholder: 'por ex. Authorization',
                valuePlaceholder: 'Valor',
                addRow: 'Adicionar cabeçalho',
                removeRow: 'Remover cabeçalho',
                maskedHint: '•••••• reintroduza para substituir',
                renamedHint: 'Renomeado — reintroduza o valor',
                versionRequired: 'Obrigatório',
                versionLatestHint: 'a mais recente é',
                versionLatestSuffix: 'a mais recente',
                empty: 'Sem cabeçalhos personalizados. Adicione um para autenticar os seus pedidos.'
            },
            validation: {
                nameRequired: 'O nome é obrigatório',
                endpointRequired: 'A URL é obrigatória',
                reasonsRequired: 'Selecione pelo menos um tipo de relatório',
                headerKeyRequired: 'A chave do cabeçalho é obrigatória',
                headerValueRequired: 'O valor do cabeçalho é obrigatório',
                headerKeyDuplicate:
                    'As chaves dos cabeçalhos têm de ser únicas',
                versionReserved:
                    'traplinked-Version é definido acima, não como cabeçalho personalizado'
            },
            reasonGroupLabels: {
                device: 'Estado do dispositivo',
                trap: 'Eventos da armadilha',
                image: 'Imagens',
                heartbeat: 'Heartbeat',
                activity: 'Atividade e isco'
            },
            reasonLabels: {
                image_received: 'Imagem recebida',
                image_ai_processed: 'Imagem processada por IA',
                heartbeat_received: 'Heartbeat recebido',
                trap_triggered: 'Armadilha ativada',
                battery_low: 'Bateria fraca',
                catch_detected: 'Captura detetada',
                rearmed: 'Rearmada',
                offline: 'Offline',
                online: 'Online',
                configured: 'Configurado (configuração inicial de fábrica)',
                maintained: 'Mantido (serviço de fábrica)',
                switched_off: 'Desligado',
                catch_reported: 'Captura comunicada',
                false_triggering: 'Ativação falsa',
                activity_noticed: 'Atividade detetada',
                activity_threshold_reached: 'Limite de atividade atingido',
                bait_low: 'Nível de isco baixo',
                activity_threshold_reached_and_bait_low:
                    'Limite de atividade atingido e nível de isco baixo'
            },
            typeLabels: {
                traplinked: 'traplinked',
                rentokil_tom_images: 'Rentokil imagens TOM',
                pestsoft: 'Pestsoft',
                axinsectai: 'AxInsectAI'
            },
            methodLabels: {
                post: 'POST',
                put: 'PUT',
                patch: 'PATCH',
                get: 'GET',
                delete: 'DELETE'
            }
        },
        billingNotice:
            'As integrações e chaves API ativas custam 0,10 € por dispositivo por mês para dispositivos que enviaram pelo menos um sinal desde o primeiro dia do mês. Os dispositivos criados a 31.12.2024 ou antes estão isentos.',
        openBillingDashboard: 'Abrir painel de faturação',
        billingDataLoadFailed:
            'Falha ao carregar a visão geral de integrações e faturação',
        billingModalTitle: 'Esta ativação afeta a sua faturação',
        billingModalIntro:
            'Ativar qualquer integração, chave API ou webhook inicia a faturação para a sua organização. Detalhes:',
        billingModalRulePrice: 'Custo: 0,10 € por dispositivo por mês',
        billingModalRuleHeartbeat:
            'São cobrados apenas dispositivos que tenham enviado pelo menos um sinal (heartbeat) durante o mês',
        billingModalRuleGrandfathered:
            'Os dispositivos online desde ou antes de 31.12.2024 não geram custos',
        billingModalConfirm: 'Concordo, ativar',
        billingModalCancel: 'Cancelar'
    },
    sagasMsgs: {
        /* common */
        getReportSharingHistoryEx: 'Erro ao obter o histórico de partilha',
        commonLoadingError:
            'Alguma coisa correu mal. Por favor, tente novamente',
        /* login */
        loginEx: 'Os dados de login estão incorrectos',
        loginWithTsEx: 'Ocorreu um erro, por favor contacte o apoio.',
        sessionEx: 'A sua sessão expirou',
        verify2faEx: 'Código inválido ou expirado. Por favor, tente novamente.',
        updataProfileRes: 'O perfil foi actualizado.',
        updataProfileEx: 'Erro durante a actualização do perfil',
        pswdChangeRes: 'A palavra-passe foi alterada.',
        pswdChangeEx:
            'Erro ao alterar a palavra-passe, certifique-se de que a palavra-passe antiga está correcta.',
        forgotPswdRes:
            'Foi enviado para o seu endereço electrónico um link para redefinir a sua palavra-passe.',
        forgotPswdEx:
            'Ocorreu um erro ao solicitar a redefinição da palavra-passe',
        resetPswdRes:
            'A palavra-chave foi alterada com sucesso, agora pode iniciar sessão.',
        resetPswdEx:
            'Ocorreu um erro, por favor tente redefinir a senha novamente na página de login',
        saveLocaleEx: 'Ocorreu um erro ao tentar salvar a definição da língua.',
        /* customers */
        getCustomersEx: 'Ocorreu um erro durante o carregamento dos clientes',
        getCustomerEx: 'Ocorreu um erro durante o carregamento do cliente',
        updateCustomerEx: 'Ocorreu um erro durante a actualização do cliente',
        updateCustomerRes: 'O cliente foi actualizado com sucesso',
        getSoftwarePlansEx:
            'Ocorreu um erro durante o carregamento de planos de software',
        /* locations */
        getLocationsEx: 'Ocorreu um erro durante o carregamento dos locais',
        getLocationEx: 'Ocorreu um erro ao carregar o local',
        updateLocationRes: 'A localização foi actualizada com sucesso',
        updateLocationEx: 'Ocorreu um erro durante a actualização do local',
        createLocationRes: 'A localização foi criada com sucesso',
        createLocationEx: 'Ocorreu um erro durante a criação do local',
        deleteLocationRes: 'Localização(ões) apagada(s) com sucesso',
        deleteLocationEx: 'Ocorreu um erro ao apagar o(s) local(is)',
        shareLocationRes: 'Partilhado com sucesso',
        shareLocationEx: 'Ocorreu um erro durante a partilha do(s) local(is)',
        getLocationDevicesEx:
            'Ocorreu um erro ao obter os dispositivos de localização',
        getLocationReportsEx:
            'Ocorreu um erro durante a obtenção de relatórios de localização',
        getLocationSharedUsersEx:
            'Ocorreu um erro durante a obtenção de informação de partilha de localização',
        getAvailableDevicesEx:
            'Ocorreu um erro ao carregar os dispositivos disponíveis para adicionar',
        moveDevicesRes: 'Adicionou com sucesso dispositivos à localização',
        moveDevicesEx:
            'Ocorreu um erro ao adicionar dispositivos à localização',
        createFloorPlanRes: 'Planta baixa has been successfully created',
        createFloorPlanEx: 'Ocorreu um erro durante a criação da planta baixa',
        getFloorPlanEx:
            'Ocorreu um erro durante o carregamento da planta baixa',
        deleteFloorPlanRes: 'Planta baixa eliminada com sucesso',
        deleteFloorPlanEx: 'Ocorreu um erro ao apagar a planta baixa',
        getFPAvailableDevicesEx:
            'Ocorreu um erro ao carregar os dispositivos disponíveis para adicionar à planta baixa',
        addDevicesToFPEx:
            'Ocorreu um erro ao adicionar dispositivos à planta do chão',
        updateFPDeviceEx:
            'Ocorreu um erro ao actualizar o dispositivo de planta baixa',
        deleteFPDeviceEx:
            'Ocorreu um erro ao apagar o dispositivo da planta do chão',
        /* devices */
        getDevicesEx: 'Ocorreu um erro durante o carregamento dos dispositivos',
        getDeviceEx: 'Ocorreu um erro durante o carregamento do dispositivo',
        getDeviceReportsEx:
            'Ocorreu um erro durante o carregamento dos relatórios do dispositivo',
        shareDevicesRes: 'Partilhado com sucesso',
        shareDevicesEx:
            'Ocorreu um erro durante a partilha do(s) dispositivo(s)',
        resetDeviceRes: 'Dispositivo reiniciado com sucesso',
        resetDeviceEx:
            'Ocorreu um erro durante a reinicialização do dispositivo',
        reportCatchRes: 'Captura comunicada com sucesso',
        reportCatchEx: 'Ocorreu um erro ao comunicar a captura',
        setOfflineRes: 'Colocação off-line com sucesso',
        setOfflineEx:
            'Ocorreu um erro durante a configuração do dispositivo offline',
        batteryResetRes: 'Resetar a bateria com sucesso',
        batteryResetEx: 'Ocorreu um erro durante a reinicialização da bateria',
        updateDeviceRes: 'Dispositivo actualizado com sucesso',
        updateDeviceEx: 'Ocorreu um erro durante a actualização do dispositivo',
        getPestControlSystems:
            'Ocorreu um erro durante o carregamento de sistemas de controlo de pragas',
        tomStatusResetRes: 'Reinicialização do estatuto de sucesso',
        tomStatusResetEx: 'Erro ocorrido durante a reposição do estado',
        /* reports */
        getReportsEx: 'Ocorreu um erro durante o carregamento de relatórios',
        getReportEx: 'Ocorreu um erro durante o carregamento do relatório',
        getLastReportDateEx:
            'Ocorreu um erro ao carregar a data do último relatório',
        /* user mgmt */
        getUsersEx: 'Ocorreu um erro durante o carregamento dos utilizadores',
        getUserEx: 'Ocorreu um erro durante o carregamento do utilizador',
        getRoleEx: 'Ocorreu um erro durante a função de carregamento',
        createRoleRes: 'A funçãofoi criado com sucesso',
        createRoleEx: 'Ocorreu um erro durante a criação da função',
        updateRoleRes: 'A Função foi actualizada com sucesso',
        updateRoleEx: 'Ocorreu um erro durante a actualização da função',
        getRolesEx: 'Ocorreu um erro enquanto se procurava papéis',
        updateUserRes: 'O utilizador foi actualizado com sucesso',
        updateUserEx: 'Ocorreu um erro durante a actualização do utilizador',
        createUserRes: 'O utilizador foi criado com sucesso',
        createUserEx: 'Ocorreu um erro ao criar o utilizador',
        deleteUserRes: 'Eliminado com sucesso',
        deleteUserEx: 'Ocorreu um erro durante a eliminação do utilizador',
        membershipEx: 'Ocorreu um erro ao solicitar a adesão do utilizador',
        addToOrgRes: 'Adicionou com sucesso o(s) utilizador(es) à organização',
        addToOrgEx: 'Ocorreu um erro ao adicionar utilizadores à organização',
        sendInvitationRes: 'O convite foi enviado com sucesso ao utilizador',
        sendInvitationEx: 'Ocorreu um erro ao enviar o convite',
        deleteRoleRes: 'A função foi eliminada com êxito',
        deleteRoleEx: 'Ocorreu um erro ao eliminar a função',
        /* sharing */
        revokeSharingRes: 'Acesso partilhado revogado com êxito',
        revokeSharingEx: 'Ocorreu um erro ao revogar o acesso partilhado',
        getSharingDataEx:
            'Ocorreu um erro ao carregar o componente de compartilhamento',
        shareEx: 'Ocorreu um erro ao partilhar entidades',
        /* api-keys */
        getApiKeysEx: 'Ocorreu um erro durante o carregamento das chaves API',
        createApiKeyRes: 'Chave API criada com sucesso',
        createApiKeyEx: 'Ocorreu um erro durante a criação da chave API',
        deleteApiKeyRes: 'Chave API apagada com sucesso',
        deleteApiKeyEx: 'Ocorreu um erro ao apagar a chave API',
        getApiKeyEx: 'Ocorreu um erro ao carregar a chave API',
        /* register */
        registerUserRes: 'O utilizador foi criado com sucesso',
        registerUserEx: 'Ocorreu um erro durante a criação do utilizador',
        registerCustomerRes: 'A organização foi criada com sucesso',
        pleaseUseEmail:
            'Por favor, utilize o e-mail e a palavra-chave do seu novo utilizador',
        registerCustomerEx: 'Ocorreu um erro durante a criação da organização',
        /* detached sharing */
        getDetachedSharingDataEx:
            'Ocorreu um erro durante o carregamento de dados para partilha',
        shareDetachedSharingDataRes: 'Partilhado com sucesso',
        shareDetachedSharingDataEx: 'Ocorreu um erro ao partilhar entidades',
        tomMakeReport: 'Erro ocorrido durante a criação do relatório',
        getTomPicturesEx:
            'Erro ocorrido durante o carregamento de TOM Pictures',
        mailSendRes: 'Email enviado com sucesso',
        mailSendEx: 'Falha no envio de e-mail',
        organisationPhoneEx:
            'Falha em salvar o número de telefone da organização',

        commentDeleteRes: 'Comentário eliminado com sucesso',
        commentDeleteEx:
            'Ocorreu um erro durante a eliminação de um comentário',
        commentAddRes: 'Comentário adicionado com sucesso',
        commentAddEx: 'Ocorreu um erro ao acrescentar comentário',
        commentEditRes: 'Comentário editado com sucesso',
        commentEditEx: 'Ocorreu um erro durante a edição de um comentário',
        getCommentsEx: 'Ocorreu um erro durante o carregamento de comentários',
        deviceImagesAddRes: 'Adicionado com sucesso',
        deviceImagesAddEx: 'Ocorreu um erro ao adicionar',
        deviceImagesEditRes: 'Editado com êxito',
        deviceImagesEditEx: 'Ocorreu um erro ao editar',
        getDeviceImagesEx: 'Ocorreu um erro ao carregar',
        getLocationsByCustomerIdEx:
            'An error occurred while loading locations by customer id',
        getEscalationLevelEx:
            'Ocorreu um erro ao carregar os níveis de escalonamento',
        postEscalationLevelEx:
            'Ocorreu um erro ao criar níveis de escalonamento',
        postEscalationLevelRes:
            'Níveis de escalonamento adicionados com sucesso',
        getDeviceHistoryEx:
            'Ocorreu um erro ao carregar o histórico do dispositivo',
        getUserPreferencesByTypeEx:
            'Erro ao carregar as preferências do usuário',
        patchUserPreferencesEx: 'Erro ao atualizar as preferências do usuário',
        postUserPreferencesEx: 'Erro ao criar as preferências do usuário',
        exportFileEx: 'Erro ao exportar o arquivo',
        getSimCardEx: 'Ocorreu um erro ao carregar o cartão SIM',
        updateSimCardRes: 'O cartão SIM foi atualizado com sucesso',
        updateSimCardEx: 'Ocorreu um erro ao atualizar o cartão SIM',
        createSimCardRes: 'O cartão SIM foi criado com sucesso',
        createSimCardEx: 'Ocorreu um erro ao criar o cartão SIM'
    },
    common: {
        maintenanceMode: 'Modo de manutenção',
        maintenanceDurationCustom: 'Personalizado',
        maintenanceDurationMinUnit: 'min',
        maintenanceDurationPositiveOnly:
            'Apenas números inteiros positivos são permitidos',
        maintenanceDurationDecrease: 'Diminuir minutos',
        maintenanceDurationIncrease: 'Aumentar minutos',
        maintenanceDurationMinutes: 'Minutos de manutenção',
        exitingMMode: 'Saindo do modo de manutenção',
        switchOnMMode: 'Ativar modo de manutenção',
        switchOffMMode: 'Desativar modo de manutenção',
        switchOnMModeDescr:
            'No modo de manutenção, relatórios não são criados e notificações não são enviadas.',
        switchOffMModeDescr: 'O modo de manutenção será desativado.',
        ok: 'Ok',
        name: 'Nome',
        save: 'Salve',
        search: 'Procurar',
        cancel: 'Cancelar',
        submit: 'Submeter',
        clear: 'Redefinir filtros',
        phone: 'Telefone',
        organisationPhone: 'Telefone da organização',
        email: 'E-Mail',
        organisation: 'Organização',
        role: 'Papel',
        password: 'Senha',
        passwordConfirmation: 'Confirmação da palabra-passe',
        changePassword: 'Alterar palavra-passe',
        oldPassword: 'Palavra-passe antiga',
        newPassword: 'Nova palavra-passe',
        newPasswordConfiramtion: 'Nova palavra-passe confirmation',
        errorContactSupport: 'Ocorreu um erro, por favor contacte o apoio',
        revoke: 'Revogar',
        share: 'Compartilhar',
        delete: 'Excluir',
        back: 'Voltar',
        next: 'Próximo',
        confirm: 'Confirmar',
        skip: 'Pular',
        description: 'Descrição',
        trap: 'Armadilha',
        fourHours: '4 horas',
        sixHours: '6 horas',
        twelveHours: '12 horas',
        eighteenHours: '18 horas',
        twentyFourHours: '24 horas',
        acceptTerms: 'Aceitar',
        loading: 'Carregando',
        copied: 'Copiado',
        failedToCopy: 'Falha na cópia',
        refresh: 'Actualizar',
        confirmationCode: 'Código de confirmação',
        passwordLength: 'A palavra-passe tem mais de 8 caracteres.',
        passwordSpecialChar: 'A palavra-passe tem caracteres especiais.',
        passwordNumber: 'A palavra-passe tem um número.',
        passwordCapital: 'A palavra-passe tem uma letra maiúscula.',
        passwordLetter: 'A palavra-passe tem uma carta.',
        nothingWasFound: 'Nada foi encontrado',
        update: 'Actualização',
        newVersionIsAvailable:
            'Nova versão da aplicação App Web está disponível!',
        pleaseClickUpdate:
            'Por favor clique no botão "Update" no lado direito para actualizar a aplicação e estamos prontos para ir!',
        required: 'Requeridos',
        passwordErrorMessage: 'A palavra-passe não é suficientemente forte',
        notValidEmail: 'E-mail não válido',
        assigned: 'Atribuído',
        assignment: 'Atribuição',
        done: 'Feito',
        settings: 'Definições',
        accountSettings: 'Definições de conta',
        organisationSettings: 'Configurações da organização',
        exportCsv: 'Exportação CSV',
        exportExcel: 'Exportação Excel',
        exportPdf: 'Exportação PDF',
        exportQrPdf: 'Exportar com código QR',
        createNew: 'Criar novo',
        fileTooBig: 'O ficheiro é demasiado grande',
        emailTo: 'Para',
        emailCc: 'Cc',
        advancedInformation: 'Informações avançadas',
        supportChat: 'Chat de suporte',
        account: 'Conta',
        manual: 'Manual',
        support: 'Apoio',
        about: 'Sobre',
        online: 'Online',
        offline: 'Offline',
        disconnected: 'Desconectado',
        notFilterable: 'Não filtrável',
        expandTreeNodes: 'Expandir todos os nós',
        collapseTreeNodes: 'Colapsar todos os nós',
        applyFilters: 'Aplicar Filtros',
        close: 'Fechar',
        login: 'Entrar',
        installation: 'Instalação',
        success: 'Sucesso'
    },
    tom: {
        openTomBtnTitle: 'Novas imagens a rever',
        loadMore: 'Carregar mais',
        contentType: 'Tipo de conteúdo',
        reportType: 'Tipo de relatório',
        createdAt: 'Criado em',
        updatedAt: 'Updated ad',
        status: 'Estado',
        bedbug: 'Percevejo de cama',
        ant: 'Formiga',
        roach: 'Baratas',
        moth: 'Traças',
        cockroach: 'Barata',
        fly: 'Insectos',
        other: 'Outros',
        mouse: 'Ratazana',
        rat: 'Rato',
        activated: 'Activado',
        activity: 'Atividade',
        falseTrigger: 'Falso gatilho',
        reviseReport: 'Relatório de revisão',
        openTom: 'TOM Aberto',
        user_processed: 'Utilizador processado',
        not_processed: 'Não processado',
        ai_processed: 'IA processada',
        ai_and_user_processed: 'IA e Utilizador processado',
        tomMode: 'Modo TOM',
        period: 'Período',
        pileEmpty: 'A pilha está vazia.',
        allProcessed: 'Todas as fotografias processadas.',
        deviceName: 'Nome do dispositivo',
        companyName: 'Nome da empresa',
        dateTime: 'Data e hora',
        operationMode: 'Modo de funcionamento',
        ok: 'OK',
        warning: 'Aviso',
        critical: 'Crítico',
        comments: 'Comentários',
        aiProcessed: 'Esta imagem foi processada automaticamente com IA',
        userProcessed: 'Esta imagem foi processada pelo Utilizador',
        location: 'Localização',
        system: 'Sistema',
        noDevicePictures: 'Ainda sem fotos',
        noPictures: 'Ainda não há imagens do TOM',
        notUsingTom: 'Not using our new product âTOMâ yet?',
        discoverTom: 'Descubra o TOM',
        reportedBy: 'Reportado por',
        amount: 'Montante',
        makeReport: 'Fazer relatório',
        relevantPictures: 'Imagens relevantes',
        allPictures: 'Todas as imagens'
    },
    mobileAppScreen: {
        title: 'Estamos actualmente a optimizar a nossa aplicação Web para dispositivos móveis.',
        subtitle:
            'Para obter a melhor experiência de utilizador, por favor descarregue a nossa App na App Store ou na Google Play Store.'
    },
    addressForm: {
        firstName: 'Nome',
        lastName: 'Sobrenome',
        company: 'Empresa',
        streetAndNumber: 'Rua & Número',
        zip: 'CEP',
        city: 'Cidade',
        country: 'País',
        note: 'Nota',
        companyNameRequireValidationMessage: 'O nome da empresa é obrigatório',
        companyNameMinLengthValidationMessage:
            'O nome da empresa é muito curto',
        companyNameMaxLengthValidationMessage:
            'O nome da empresa é muito longo',
        companyIsValidValidationMessage: 'Nome da empresa inválido',
        nameRequireValidationMessage: 'Nome é obrigatório',
        nameMinLengthValidationMessage: 'Nome é muito curto',
        nameMaxLengthValidationMessage: 'Nome é muito longo',
        nameIsValidValidationMessage: 'Nome inválido',
        lastNameRequireValidationMessage: 'Sobrenome é obrigatório',
        lastNameMinLengthValidationMessage: 'Sobrenome é muito curto',
        lastNameMaxLengthValidationMessage: 'Sobrenome é muito longo',
        lastNameIsValidValidationMessage: 'Sobrenome inválido',
        addressRequireValidationMessage: 'Rua & Número são obrigatórios',
        addressIsValidValidationMessage: 'Formato inválido para Rua & Número',
        zipCodeRequireValidationMessage: 'CEP é obrigatório',
        zipCodeIsValidValidationMessage: 'CEP inválido',
        cityRequireValidationMessage: 'Cidade é obrigatória',
        cityIsValidValidationMessage: 'Nome da cidade inválido',
        countryRequireValidationMessage: 'País é obrigatório',
        countryIsValidValidationMessage: 'Nome do país inválido'
    },
    billing: {
        billing: 'Faturação',
        externalUsersCreationNotice:
            'Novos usuários externos criados após 01.01.2025 serão cobrados em €2,50 líquidos mensalmente cada. Você pode encontrar a visão geral de suas assinaturas mensais no painel de faturação.',
        escalationLevelsCreationNotice:
            'Novos endereços de e-mail usados para níveis de escalação atribuídos após 01.01.2025 serão cobrados em €2,50 líquidos mensalmente cada. Você pode encontrar a visão geral de suas assinaturas mensais no painel de faturação.',
        billingDashboard: 'Painel de faturação',
        lastHeartbeat: 'Último heartbeat',
        removedAt: 'Removido em',
        externalUsers: 'Usuários externos',
        amount: 'Valor',
        apiDevices: 'API de dispositivos',
        monetisation: 'Monetização',
        itCanUpToAMinute: 'Pode demorar até um minuto',
        currentMonth: 'Mês atual'
    }
}

export default pt
